import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { foodGallery, galleryTitle, mobileGallery } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileGallery} w="100%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <CFImage src={galleryTitle} w="25%" alt="Food Gallery" />
          <CFImage src={foodGallery} w="85%" alt="Food Gallery" mv="35px" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
